import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';


class ThePlatformSolution extends Component {
	componentDidMount() {
		document.getElementById('root').classList.remove('welcome');
		document.getElementById("root").classList.remove("affiliate");
		document.getElementById('foo').classList.add('overflow');
	}
	render() {
		return (
			<div className="sub-page product">
				<Helmet>
                    <title>STech - Marketing &amp; Operational Services</title>
                    <meta name="description" content="STech - Marketing &amp; Operational Services pages" />
				</Helmet>
				<header className="clearfix fadeInUp">
					<div className="container">
						<div className="left"></div>
						<div className="right">
                            <h1>Marketing &amp; Operational Services</h1>
							<h2>Products</h2>
						</div>
					</div>
				</header>
				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">							
							<p>Stech has a top team of developers, programmers and designers and offers a full range of services including:</p>
							<ul>
								<li>IT & Operations</li>
								<li>Whitelabel solutions</li>
								<li>Marketing & CRM tools</li>
							</ul>
							<p>Our smart prices and business models promise to beat all competition.</p>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp contact">
					<div className="container">
						<h2>We grow together</h2>
						<div className="content">
							<p>STech is a hi-tech, fast-paced company but above all we aim to create business partnerships that grow over time.</p>
							<Link to="/contact">
								Contact Us
							</Link>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default ThePlatformSolution
